<script>
import * as m from '@app/paraglide/messages.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import convertToPlainTextCustom from '@cclib/functions/quill/convertToPlainTextCustom.js';
import convertToHtml from '@cclib/functions/quill/convertToHtml.js';
import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

function mergeEvents() {
    try {
        if (eventGroupState[projectState.selected].selected.length < 2) {
            return;
        }
        
        let text = "";
        let originalText = "";
        let speakers = [];
        let sortedEvents = eventGroupState[projectState.selected].selected.sort((a, b) => {
            return b - a;
        });
        
        /* Save the selected end time of the last event */
        let lastEnd = eventGroupState[projectState.selected].events[sortedEvents[0]].end;
        
        sortedEvents.forEach((eventIndex, selectedIndex) => {
            text = convertToPlainTextCustom(eventGroupState[projectState.selected].events[eventIndex].text) + "\n" + convertToPlainTextCustom(text);
            originalText = convertToPlainTextCustom(eventGroupState[projectState.selected].events[eventIndex].original) + "\n" + convertToPlainTextCustom(originalText);
            if (eventGroupState[projectState.selected].events[eventIndex].speakers && eventGroupState[projectState.selected].events[eventIndex].speakers.length > 0) {
                //Concatenate speakers to speakers array. We'll deduplicate by ID later
                speakers = [...speakers, ...eventGroupState[projectState.selected].events[eventIndex].speakers];
            }
            
            if (selectedIndex < sortedEvents.length - 1) {
                eventGroupState[projectState.selected] = removeEvent(eventGroupState[projectState.selected], eventIndex);
            }
        });
        
        // Deduplicate speakers by ID
        const uniqueSpeakers = [];
        const speakerIds = new Set();
        
        speakers.forEach(speaker => {
            if (speaker && speaker.id && !speakerIds.has(speaker.id)) {
                speakerIds.add(speaker.id);
                uniqueSpeakers.push(speaker);
            }
        });

        eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].text = convertToHtml(text);
        eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].original = convertToHtml(originalText);
        eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].end = lastEnd || eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].end;
        eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].speakers = uniqueSpeakers;
        eventGroupState[projectState.selected].events[sortedEvents[sortedEvents.length - 1]].rendered = false;
        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "merge events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<a
    id="mergeEventsBtn"
    class="dropdown-item"
    role="button"
    aria-label={m.context_menu_merge_label()}
    href="#!/"
    onclick={mergeEvents}>
    {m.context_menu_merge()}
</a>
